import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { overviewFieldLabelTypography } from './overviewFieldStyles';

/**
 * Styling for the note "Cc" field: the collapsed "Add Cc" link, the label, the selected-recipient
 * token pills, and the recipient typeahead. All tokens come from `THEME`.
 */
export const noteCcFieldStyles = StyleSheet.create({
	addCc: {
		alignSelf: 'flex-start',
		height: 'auto',
		padding: 0,
	},
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	label: {
		...overviewFieldLabelTypography,
	},
	tokens: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.xs,
	},
	token: {
		alignItems: 'center',
		backgroundColor: THEME.colors.background.main,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.text.main,
		display: 'inline-flex',
		fontSize: THEME.typography.fontSizes.sm,
		gap: THEME.spacing.xs,
		padding: `2px 2px 2px ${THEME.spacing.sm}px`,
	},
	removeToken: {
		color: THEME.colors.text.light,
		height: 'auto',
		padding: THEME.spacing.xs,
	},
	control: {
		width: '100%',
	},
});
